/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { date, DateFormat, entity, subentity } from '@gh/core-data';
import { MasterZoneDetailsDto } from './master-zone-details.dto';

export const MasterZoneDetailsMapper = entity<MasterZoneDetailsDto>({
  formedDate: date(DateFormat.Date),
  billing: subentity<any>({
    contractSignedDate: date(DateFormat.Date),
    depositDate: date(DateFormat.Date),
    commencementDate: date(DateFormat.Date),
    currentAgreement: date(DateFormat.Date),
    renewalDate: date(DateFormat.Date),
    closedDate: date(DateFormat.Date),
    onSellDate: date(DateFormat.Date),
    originalAgreementDate: date(DateFormat.Date),
  }),
});
